<div *ngIf="dealer" class="container-fluid">
    <app-header titleText="{{pageTitle}}" isAdmin="true">
        <div account>
            <img src="assets/img/circle_images/admin_circle.png" class="account-image" width="60" alt="My Account Icon" />
            <label class="text-bidit-primary-header" i18n>My Account</label>
        </div>
    </app-header>
    <div class="row">
        <div id="dealerInfo" class="col-md-4 mb-3">
            <div class="form-inline">
                <img src="assets/img/circle_images/admin_circle.png" class="account-image" width="60" alt="My Account Icon" />
                <label class="text-bidit-primary-header pr-3" i18n>My Account</label>
                <a (click)="showEdit()" class="btn btn-bidit-navigate btn-sm" i18n>Edit</a>
            </div>
            <div class=" pl-5">
                <div>{{dealer.dealer_BusinessName}}</div>
                <div>{{dealer.dealer_FirstName}} {{dealer.dealer_LastName}}</div>
                <div>{{dealer.dealer_Address1}} {{dealer.dealer_Address2}}</div>
                <div>{{dealer.dealer_City}}, {{dealer.dealer_State}} {{dealer.dealer_Postal}}</div>
                <div class=" pt-3"><span i18n>Office Hours:</span> {{dealer.dealer_OfficeHours}}</div>
                <div><span i18n>Accepts EULA?</span>  {{dealer.eula_IsAccepted}} </div>
                <div><span i18n>Quote Expires in</span> {{dealer.dealer_QuoteExpires}} <span>Days</span></div>
            </div>
        </div>
        <div id="dealerlogo" class="col-md-8 col-sm-12">
            <app-logo></app-logo>
        </div>
    </div>

    <div *ngIf="!quoteOnly" class="pt-5 term-language">
        <div style="width: 250px;">
            Target Language:
        </div>
        <select name="termLocale" class="form-control select-bidit" [(ngModel)]="termLocale">
            <option value="en">English</option>
            <option value="es">Español</option>
        </select>
    </div>
    <div *ngIf="!quoteOnly" class="card-deck">
        <div class="card bg-light">
            <app-text textType="sales" [locale]="termLocale" [dealer]="dealer"></app-text>
        </div>
        <div class="card bg-light">
            <app-text textType="contract" [locale]="termLocale" [dealer]="dealer"></app-text>
        </div>
        <div class="card bg-light">
            <app-text textType="total" [locale]="termLocale" [dealer]="dealer"></app-text>
        </div>
    </div>
</div>
